import './TextSelectTools.css';
import { NebulaButton as w, NebulaButtonGroup as _ } from "@discoveryedu/nebula-components";
import { E as v } from "./platform-components-assets/index-es.js";
import { s as E } from "./platform-components-assets/note-es.js";
import b from "./DomHelper.js";
import { H as m } from "./platform-components-assets/highlight-es.js";
import p from "./HighlightHelper.js";
import k from "./SelectionHelper.js";
import A from "./textToSpeech.js";
import { resolveComponent as x, openBlock as T, createElementBlock as y, normalizeStyle as N, createElementVNode as C, createVNode as c, withCtx as D, mergeProps as g, withModifiers as d, createCommentVNode as S } from "vue";
import { _ as I } from "./platform-components-assets/_plugin-vue_export-helper-es.js";
const O = {
  name: "TextSelectTools",
  components: {
    NebulaButton: w,
    NebulaButtonGroup: _
  },
  data() {
    return {
      activeTool: "tts",
      cachedSelectionData: null,
      cachedSelectedText: null,
      contextContainer: null,
      cooldownTimerId: null,
      currentHighlight: null,
      currentHighlightColor: null,
      currentHighlightNote: null,
      eventAbortController: new AbortController(),
      eventBus: new v(),
      highlightHelper: null,
      ignoredSelection: null,
      loadTextToSpeech: this.useSpeechTools,
      pointerCoordinates: {
        x: null,
        y: null
      },
      selectedText: null,
      ttsControlsOpen: !1,
      toolsEnabled: !0,
      noteToolEnabled: !0,
      highlightToolsEnabled: !0,
      selectionHelper: null,
      selectWrapperObserver: null
    };
  },
  props: {
    // textSelectTools expects to get locked to a parent HTMLElement
    contextContainerSelector: {
      type: String,
      required: !0
    },
    pageData: {
      type: Object,
      required: !1
    },
    ignoredElements: {
      type: Array,
      default() {
        return [];
      }
    },
    initData: {
      type: Object,
      required: !1
    },
    metadata: {
      type: Object,
      default() {
        return {};
      }
    },
    nodeSelectors: {
      type: Object,
      required: !0
    },
    useHighlights: {
      type: Boolean,
      default: !0
    },
    useNotes: {
      type: Boolean,
      default: !0
    },
    useSpeechTools: {
      type: Boolean,
      default: !0
    },
    apiOrigin: {
      type: String,
      default: null
    },
    apiVersion: {
      type: Number,
      default: 1,
      validator(t) {
        return [1, 2].includes(t);
      }
    },
    offsetX: {
      type: Number,
      default: 0
    },
    offsetY: {
      type: Number,
      default: 0
    },
    useIntersectionObserver: {
      type: Boolean,
      default: !0
    },
    buttonPlayAttributes: {
      type: Object,
      default: () => ({})
    },
    buttonAddNoteAttributes: {
      type: Object,
      default: () => ({})
    },
    buttonRemoveNoteAttributes: {
      type: Object,
      default: () => ({})
    },
    buttonYellowAttributes: {
      type: Object,
      default: () => ({})
    },
    buttonPinkAttributes: {
      type: Object,
      default: () => ({})
    },
    buttonGreenAttributes: {
      type: Object,
      default: () => ({})
    },
    buttonBlueAttributes: {
      type: Object,
      default: () => ({})
    }
  },
  mixins: [A],
  emits: [
    "create-note",
    "highlight-created",
    "highlight-deleted",
    "highlights-retrieved",
    "highlight-updated",
    "show-note",
    "pointer-coordinates-reset"
  ],
  mounted() {
    if (this.contextContainer = document.querySelector(this.contextContainerSelector), this.highlightHelper = new p({
      contextContainer: this.contextContainer,
      ignoredElements: this.ignoredElements,
      nodeSelectors: this.nodeSelectors
    }), this.apiOrigin && (p.apiOrigin = this.apiOrigin, E(this.apiOrigin)), this.$nebulaSVGPath && (m.iconsSvgPath = this.$nebulaSVGPath), this.selectionHelper = new k({
      contextContainer: this.contextContainer,
      ignoredElements: this.ignoredElements,
      nodeSelectors: this.nodeSelectors
    }), this.retrieveHighlights(), this.checkHighlights(), !this.useSpeechTools) {
      this.startTextSelect();
      return;
    }
    this.eventBus.on("tts:initialized", () => {
      this.startTextSelect();
      const { domControlTools: t, speechTools: e } = this.speechstream;
      t.setStartPoint(this.contextContainer), e.setContinuousReading(!1);
    }), this.eventBus.on("tts:page-complete", (t) => {
      t.length || (this.selectionHelper.selection.unmark(), this.getCurrentHighlight() || this.resetSelection(), !this.getCurrentHighlight() && (this.checkSelection().isIgnored || this.checkSelection().isPartiallyIgnored) && this.closeTools()), this.ignoredSelection && this.closeTools();
    });
  },
  computed: {
    version() {
      return this.metadata.references && this.metadata.references.length ? 2 : this.apiVersion;
    },
    coords() {
      const { x: t, y: e } = this.pointerCoordinates;
      return {
        left: `${t}px`,
        top: `${e}px`
      };
    },
    isHighlight() {
      return this.checkSelection().isHighlight;
    },
    isInCooldown() {
      return !!this.cooldownTimerId;
    },
    statusIcon() {
      return this.isPaused ? "play" : this.isSpeaking || this.readableElements.length ? "pause" : "play";
    },
    statusText() {
      return this.isPaused ? this.$t("Play Text") : this.isSpeaking || this.readableElements.length ? this.$t("Pause Text") : this.$t("Play Text");
    },
    ttsActive() {
      return this.activeTool === "tts";
    },
    highlightActive() {
      return this.activeTool === "highlight";
    },
    highlightToken() {
      return this.initData.csrf_tokens.notebook.highlight;
    },
    noteToken() {
      return this.initData.csrf_tokens.notebook.note;
    }
  },
  methods: {
    addOrViewNote() {
      if (this.checkSelection(), this.currentHighlightNote) {
        this.showNote(this.currentHighlight), this.closeTools();
        return;
      }
      this.createNote();
    },
    checkSelection() {
      const {
        startNode: t,
        endNode: e
      } = this.getSelection(), i = this.getCurrentHighlight(), { domHelper: o } = this.selectionHelper;
      this.noteToolEnabled = !0, this.highlightToolsEnabled = !0, i ? (this.currentHighlightColor = i.color, this.currentHighlightNote = i.note) : (this.currentHighlightColor = null, this.currentHighlightNote = null);
      const s = {
        activeHighlight: null,
        isHighlight: !!i,
        isIgnored: o.isNodeInIgnoredList(t) && o.isNodeInIgnoredList(e),
        isPartiallyIgnored: o.isNodeInIgnoredList(t) || o.isNodeInIgnoredList(e),
        startNodeHighlight: null,
        endNodeHighlight: null,
        intermediateHighlights: [],
        areToolsEnabled: null
      };
      (s.isIgnored || s.isPartiallyIgnored) && (this.ignoredSelection = !0);
      const {
        allHighlights: l,
        endNodeHighlight: h,
        intermediateHighlights: u,
        notes: a,
        startNodeHighlight: f
      } = p.state;
      s.endNodeHighlight = h, s.startNodeHighlight = f, s.intermediateHighlights = u;
      const n = a.length < 2;
      if (s.areToolsEnabled = n, this.noteToolEnabled = n, this.highlightToolsEnabled = n, l.length) {
        const r = l.find((H) => !!H.note);
        s.activeHighlight = r || l[0], s.activeHighlight && (this.currentHighlight = s.activeHighlight, this.currentHighlightColor = s.activeHighlight.color, this.currentHighlightNote = s.activeHighlight.note);
      }
      return s;
    },
    clearCooldownTimer() {
      this.cooldownTimerId && (clearTimeout(this.cooldownTimerId), this.cooldownTimerId = null);
    },
    closeTools() {
      const t = this.getCurrentHighlight();
      t && t.deselect(), this.handleStop(), this.activeTool = "tts", this.ttsControlsOpen = !1, this.ignoredSelection = null, this.startCooldownTimer();
    },
    disableTools() {
      this.toolsEnabled = !1;
    },
    enableTools() {
      this.toolsEnabled = !0;
    },
    getCurrentHighlight() {
      return m.activeHighlight;
    },
    getSelection() {
      return this.selectionHelper.selection;
    },
    // IS THIS THE RIGHT PLACE FOR THIS?
    async createNote() {
      let t = this.getCurrentHighlight();
      t || (t = await this.handleHighlight()), this.$emit("create-note", t), window.DEAnalytics && window.DEAnalytics.linkClicked({
        name: "Add Note",
        type: "TTS Action Bar"
      });
    },
    showNote(t = null) {
      const e = t || this.getCurrentHighlight();
      this.$emit("show-note", e.note), window.DEAnalytics && window.DEAnalytics.linkClicked({
        name: "View Note",
        type: "TTS Action Bar"
      });
    },
    handlePlay() {
      if (this.isSpeaking || this.isPaused || this.hasReadableElements) {
        this.pause(), window.DEAnalytics && window.DEAnalytics.linkClicked({
          name: "Pause Text",
          type: "TTS Action Bar"
        });
        return;
      }
      const t = this.getCurrentHighlight(), e = t ? t.selection : this.getSelection();
      this.cachedSelectionData = e ? e.getData() : null;
      let i;
      if (!this.useHighlights) {
        this.play(), window.DEAnalytics && window.DEAnalytics.linkClicked({
          name: "Play Text",
          type: "TTS Action Bar"
        });
        return;
      }
      const o = this.checkSelection();
      if (!t && (o.isIgnored || o.isPartiallyIgnored)) {
        this.play(), window.DEAnalytics && window.DEAnalytics.linkClicked({
          name: "Play Text",
          type: "TTS Action Bar"
        });
        return;
      }
      t ? i = t.getHighlightElements() : i = this.selectionHelper.selection.mark("de-speakable"), this.speakElements(i), window.DEAnalytics && window.DEAnalytics.linkClicked({
        name: "Play Text",
        type: "TTS Action Bar"
      });
    },
    handleStop() {
      (this.isSpeaking || this.isPaused || this.hasReadableElements) && (this.stop(), this.selectionHelper.selection.unmark());
    },
    // Defaults to 'yellow for notes'
    async handleHighlight(t = "yellow") {
      var s, l, h, u, a, f;
      const e = this.getCurrentHighlight();
      if (this.handleStop(), this.disableTools(), e)
        return e.setColor(t), await this.saveHighlight(e), this.currentHighlightColor = e.color, this.$emit("highlight-updated", e), this.enableTools(), e;
      let i;
      if (this.version === 2)
        i = this.metadata;
      else {
        const n = this.getSelection(), { commonAncestor: r } = n, H = r.closest("[data-guid]").dataset.guid;
        i = {
          ...this.metadata,
          asset_id: H,
          concept_id: this.initData.concept_id,
          course_id: this.initData.course_id,
          page_id: (s = this.pageData.page) == null ? void 0 : s.id,
          relationship_type_id: this.initData.tab_id,
          subdiscipline_id: (u = (h = (l = this.pageData.concept) == null ? void 0 : l.unit) == null ? void 0 : h.subdiscipline) == null ? void 0 : u.id,
          unit_id: (f = (a = this.pageData.concept) == null ? void 0 : a.unit) == null ? void 0 : f.id
        };
      }
      let o;
      return await this.highlightHelper.createOrUpdate(
        this.selectionHelper,
        t,
        i,
        this.highlightToken
      ).then(async (n) => {
        if (n.isNoop) {
          this.enableTools(), this.closeTools();
          return;
        }
        o = n.highlight, n != null && n.deletedHighlights.length && n.deletedHighlights.forEach((r) => this.$emit("highlight-deleted", r)), n.hasNewNote && (await o.note.create(
          {
            highlight: o,
            note: o.note
          },
          this.noteToken
        ), o.injectNoteElement(o.note)), n.updatedHighlights.forEach((r) => this.$emit("highlight-updated", r)), n.createdHighlights.forEach((r) => this.$emit("highlight-created", r)), this.enableTools(), this.closeTools();
      }).finally(() => {
        const n = [...document.querySelectorAll(".de-note")];
        n.length && n.forEach((r) => {
          b.isNodeInSelector(r, "mark") || r.remove();
        });
      }), o;
    },
    async removeHighlight() {
      const t = this.getCurrentHighlight();
      if (this.handleStop(), !t) {
        this.closeTools();
        return;
      }
      await t.delete(), this.$emit("highlight-deleted", t), this.closeTools();
    },
    resetSelection() {
      if (!this.cachedSelectionData)
        return;
      const t = this.getSelection();
      t.updateFromData(
        this.cachedSelectionData
      ), t.select();
    },
    async retrieveHighlights() {
      var i, o;
      if (!this.useHighlights)
        return;
      let t;
      (i = this.initData) != null && i.highlightsData ? t = this.initData.highlightsData : this.version === 2 && ((o = this.metadata.references) != null && o.length) ? t = await p.retrieveAllHighlightsByReference(this.metadata.references) : t = await p.retrieveAllHighlights(this.initData.concept_id);
      const e = t.reduce(
        (s, l) => {
          const h = this.highlightHelper.createFromData(l);
          return h && (s.push(h), h.eventBus.on("select", this.onSelectHighlight, this)), s;
        },
        []
      );
      this.$emit("highlights-retrieved", e);
    },
    async saveHighlight(t) {
      return t.save(this.highlightToken);
    },
    checkHighlights() {
      document.querySelectorAll(".de-highlight").forEach((e) => {
        e.ontouchend || (e.ontouchend = (i) => {
          this.selectMarkElement(i);
        });
      });
    },
    startCooldownTimer() {
      if (this.isInCooldown)
        return;
      const t = 200;
      this.cooldownTimerId = setTimeout(
        this.clearCooldownTimer,
        t
      );
    },
    getSelectionChange() {
      const t = this.getSelection();
      if (!t)
        return;
      this.checkSelection();
      const { commonAncestor: e } = t;
      this.contextContainer.contains(e) && (this.selectedText = t.text);
    },
    onSelectHighlight(t) {
      this.selectedText = t.text;
    },
    onPointerDown(t) {
      b.compareNodePosition(this.$el, t.target).isDescendant || (this.getSelectionChange(), this.cachedSelectedText = this.selectedText, this.closeTools(), this.clearCooldownTimer());
    },
    selectMarkElement(t) {
      const { dataset: e } = t.target;
      m.getByClientId(e.highlightClientId).select(), this.pointerCoordinates.x = t.pageX - this.offsetX, this.pointerCoordinates.y = t.pageY + 20 - this.offsetY, this.$emit("pointer-coordinates-reset", this.pointerCoordinates), this.ttsControlsOpen = !0;
    },
    setPointerCoords(t) {
      const e = this.getCurrentHighlight(), i = this.getSelection(), o = i.text === this.cachedSelectedText;
      if (this.cachedSelectionData = i ? i.getData() : null, !b.compareNodePosition(this.contextContainer, t.target).isDescendant || b.compareNodePosition(this.$el, t.target).isDescendant)
        return;
      if (o && (!i || !e) && this.closeTools(), t.target.classList.contains("de-highlight") && t.pointerType !== "mouse" && (this.selectionHelper.selection.clearData(), k.clearSelection(), this.selectMarkElement(t)), this.ttsControlsOpen) {
        if (t.target.classList.contains("de-highlight") && t.pointerType !== "mouse") {
          this.selectMarkElement(t);
          return;
        }
        if (!b.compareNodePosition(this.$el, t.target).isDescendant && (!i.text || o)) {
          this.closeTools();
          return;
        }
      }
      if (!i.text && e) {
        this.pointerCoordinates.x = t.pageX - this.offsetX, this.pointerCoordinates.y = t.pageY + 10 - this.offsetY, this.$emit("pointer-coordinates-reset", this.pointerCoordinates), this.ttsControlsOpen = !0;
        return;
      }
      if (this.isInCooldown)
        return;
      if (!!!i.text) {
        this.closeTools();
        return;
      }
      this.handleStop(), this.pointerCoordinates.x = t.pageX - this.offsetX, this.pointerCoordinates.y = t.pageY + 10 - this.offsetY, this.$emit("pointer-coordinates-reset", this.pointerCoordinates), this.ttsControlsOpen = !0, this.$nextTick(() => {
        this.checkIntersection();
      });
    },
    startTextSelect() {
      const { signal: t } = this.eventAbortController;
      this.selectionHelper.eventBus.on(
        "selection:change",
        this.getSelectionChange,
        this
      ), document.addEventListener(
        "pointerdown",
        (e) => this.onPointerDown(e),
        {
          signal: t
        }
      ), document.addEventListener(
        "pointerup",
        (e) => this.setPointerCoords(e),
        {
          signal: t
        }
      ), document.addEventListener("touchend", (e) => {
        const i = e.target.closest(".nebula-button");
        i && (e.preventDefault(), i.click());
      }, { signal: t });
    },
    toggleActiveTools(t) {
      const { currentTarget: e } = t;
      this.activeTool = e.dataset.tool;
    },
    checkIntersection() {
      if (!this.useIntersectionObserver)
        return;
      const t = document.querySelector(".text-select__wrapper");
      t && (this.selectWrapperObserver = new IntersectionObserver((e) => {
        e.forEach((i) => {
          if (i.isIntersecting) {
            const o = i.boundingClientRect.width, s = i.intersectionRect.width, l = o - s + 16;
            this.pointerCoordinates.x = i.intersectionRect.x - l - this.offsetX;
          }
        });
      }), this.ttsControlsOpen ? this.selectWrapperObserver.observe(t) : this.selectWrapperObserver.unobserve(t));
    }
  },
  updated() {
    this.checkHighlights();
  },
  beforeUnmount() {
    var t;
    this.eventAbortController.abort(), this.selectionHelper.eventBus.off(), this.selectionHelper.destroy(), this.highlightHelper && p.remove((t = this.highlightHelper) == null ? void 0 : t.clientId), this.selectWrapperObserver && this.selectWrapperObserver.disconnect(), m.highlights.forEach((e) => {
      e.eventBus.off("select", this.onSelectHighlight);
    });
  },
  watch: {
    ttsControlsOpen(t) {
      t && this.$nextTick(() => {
        if (document.querySelector(".notes-panel__note--error")) {
          this.ttsControlsOpen = !this.ttsControlsOpen;
          return;
        }
        this.checkIntersection();
      });
    }
  }
}, P = { class: "text-select__controls-wrapper" }, B = { class: "text-select__controls-options" }, j = { class: "text-select__controls-tts-buttons" }, R = {
  key: 0,
  class: "text-select__controls-notes-button"
}, V = {
  key: 1,
  class: "text-select__controls-highlight-buttons"
};
function Y(t, e, i, o, s, l) {
  const h = x("NebulaButton"), u = x("NebulaButtonGroup");
  return (!s.loadTextToSpeech || t.speechstream) && (s.ttsControlsOpen || t.isSpeaking || t.isPaused) ? (T(), y("div", {
    ref: "textSelect",
    class: "text-select__wrapper",
    style: N(l.coords),
    key: l.getCurrentHighlight()
  }, [
    C("div", P, [
      C("div", B, [
        c(u, { class: "text-select__controls" }, {
          buttons: D(() => [
            C("div", j, [
              c(h, g({
                "aria-label": l.statusText,
                class: `text-select__button text-select__button--${l.statusIcon}`,
                onClick: d(l.handlePlay, ["stop"]),
                "icon-left": l.statusIcon,
                "is-disabled": !s.toolsEnabled,
                text: l.statusText
              }, i.buttonPlayAttributes, {
                size: "s",
                type: "flat"
              }), null, 16, ["aria-label", "class", "onClick", "icon-left", "is-disabled", "text"])
            ]),
            i.useNotes && !s.ignoredSelection ? (T(), y("div", R, [
              c(h, g({
                class: "text-select__button text-select__button--notes",
                onClick: d(l.addOrViewNote, ["stop"]),
                "icon-left": "highlight-note",
                "is-disabled": !s.toolsEnabled || !s.noteToolEnabled
              }, i.buttonAddNoteAttributes, {
                text: s.currentHighlightNote ? t.$t("View Note") : t.$t("Add Note"),
                size: "s",
                type: "flat"
              }), null, 16, ["onClick", "is-disabled", "text"])
            ])) : S("", !0),
            i.useHighlights && (!s.ignoredSelection || l.isHighlight) ? (T(), y("div", V, [
              c(h, g({
                "aria-label": t.$t("Remove Highlight"),
                class: "text-select__highlight-button text-select__highlight-button--remove",
                "is-disabled": !l.getCurrentHighlight() || !s.toolsEnabled || !!this.currentHighlightNote,
                type: "flat",
                size: "s",
                "icon-left": "checkbox-strike"
              }, i.buttonRemoveNoteAttributes, {
                onClick: d(l.removeHighlight, ["prevent"]),
                "data-click-type": "TTS Action Bar",
                "data-click-name": "Remove Highlight"
              }), null, 16, ["aria-label", "is-disabled", "onClick"]),
              c(h, g({
                "aria-label": t.$t("Highlight Yellow"),
                class: ["text-select__highlight-button text-select__highlight-button--yellow", { "text-select__highlight-button--active": s.currentHighlightColor === "yellow" }],
                "is-disabled": !s.toolsEnabled || !s.highlightToolsEnabled,
                type: "flat",
                size: "s",
                "icon-left": "checkbox-empty"
              }, i.buttonYellowAttributes, {
                onClick: e[0] || (e[0] = d((a) => l.handleHighlight("yellow"), ["prevent"])),
                "data-click-type": "TTS Action Bar",
                "data-click-name": "Add Highlight-Yellow"
              }), null, 16, ["aria-label", "class", "is-disabled"]),
              c(h, g({
                "aria-label": t.$t("Highlight Pink"),
                class: ["text-select__highlight-button text-select__highlight-button--pink", { "text-select__highlight-button--active": s.currentHighlightColor === "pink" }],
                "is-disabled": !s.toolsEnabled || !s.highlightToolsEnabled,
                type: "flat",
                size: "s",
                "icon-left": "checkbox-empty"
              }, i.buttonPinkAttributes, {
                onClick: e[1] || (e[1] = d((a) => l.handleHighlight("pink"), ["prevent"])),
                "data-click-type": "TTS Action Bar",
                "data-click-name": "Add Highlight-Pink"
              }), null, 16, ["aria-label", "class", "is-disabled"]),
              c(h, g({
                "aria-label": t.$t("Highlight Green"),
                class: ["text-select__highlight-button text-select__highlight-button--green", { "text-select__highlight-button--active": s.currentHighlightColor === "green" }],
                "is-disabled": !s.toolsEnabled || !s.highlightToolsEnabled,
                type: "flat",
                size: "s",
                "icon-left": "checkbox-empty"
              }, i.buttonGreenAttributes, {
                onClick: e[2] || (e[2] = d((a) => l.handleHighlight("green"), ["prevent"])),
                "data-click-type": "TTS Action Bar",
                "data-click-name": "Add Highlight-Green"
              }), null, 16, ["aria-label", "class", "is-disabled"]),
              c(h, g({
                "aria-label": t.$t("Highlight Blue"),
                class: ["text-select__highlight-button text-select__highlight-button--blue", { "text-select__highlight-button--active": s.currentHighlightColor === "blue" }],
                "is-disabled": !s.toolsEnabled || !s.highlightToolsEnabled,
                type: "flat",
                size: "s",
                "icon-left": "checkbox-empty"
              }, i.buttonBlueAttributes, {
                onClick: e[3] || (e[3] = d((a) => l.handleHighlight("blue"), ["prevent"])),
                "data-click-type": "TTS Action Bar",
                "data-click-name": "Add Highlight-Blue"
              }), null, 16, ["aria-label", "class", "is-disabled"])
            ])) : S("", !0)
          ]),
          _: 1
        })
      ])
    ])
  ], 4)) : S("", !0);
}
const K = /* @__PURE__ */ I(O, [["render", Y]]);
export {
  K as default
};
